import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetCanClientFulFillRequests_facility$key } from "./__generated__/useGetCanClientFulFillRequests_facility.graphql";

export const useGetCanClientFulFillRequests = (
  facilityRef: useGetCanClientFulFillRequests_facility$key | null | undefined
) => {
  const data = useFragment(
    useGetCanClientFulFillRequestsFragmentString,
    facilityRef
  );

  if (!data) {
    return false;
  }

  const supportsPublic = data.club?.supportsPublic ?? false;

  const canFulfill = supportsPublic
    ? data.publicBookingPermissionSet?.clientCanFulfillRequests ?? false
    : data.privateBookingPermissionSet?.clientCanFulfillRequests ?? false;

  return canFulfill;
};

const useGetCanClientFulFillRequestsFragmentString = graphql`
  fragment useGetCanClientFulFillRequests_facility on Facility {
    club {
      supportsPublic
    }
    privateBookingPermissionSet {
      clientCanFulfillRequests
    }
    publicBookingPermissionSet {
      clientCanFulfillRequests
    }
  }
`;
